import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { useAuthorization } from '../../authentication'
import { userEntityQueries } from '../apis'

export const useUserEntity = () => {
  const { bearerToken, isAuthorized } = useAuthorization()
  const { data: userInfo } = useQuery({
    ...userEntityQueries.getCurrentUser({ bearerToken }),
    enabled: isAuthorized,
  })

  return userInfo
}

export const useSuspenseUserEntity = () => {
  const { bearerToken } = useAuthorization()
  const { data: userInfo } = useSuspenseQuery({
    ...userEntityQueries.getCurrentUser({ bearerToken }),
  })

  return userInfo
}
